// @flow
import React, { Component } from 'react';
import {
  ImportCsvDiv,
  DownloadIconTextLinkDiv,
  DownloadCsvItemDiv,
  StyledA
} from './ImportCsvStyles';
import { DefaultIcon } from '../../../../components/Icon';
import UploadCsvForm from './UploadCsvForm';
import downloadFile from '../../../../assets/images/download-file.png';
import FailedMerchants from './FailedMerchants';
import { Mobile, Default } from '../../../../components/Responsive';
import { MerchantRegistrationHeaderDiv } from '../RegistrationForms/RegistrationStyles';
import {
  MerchantReferralOptionDiv,
  OptionHeaderDiv,
  MerchantRegistrationOptionDiv,
  MerchantReferralOptionHeader
} from '../MerchantRegistrationsStyles';
import RegistrationMethodsNav from '../RegistrationMethodsNav';

type Props = {
  location: {
    pathname: string
  }
};

export default class ImportCsv extends Component<Props> {
  render() {
    return (
      <div>
        <MerchantReferralOptionDiv largePaddingBottom>
          <OptionHeaderDiv>
            <h5>Option 3</h5>
          </OptionHeaderDiv>
          <MerchantRegistrationOptionDiv>
            <MerchantReferralOptionHeader>
              <h5>Register on behalf of your merchants</h5>
              <p>
                Register on behalf of your merchants by using one of the three
                registration methods below.
              </p>
            </MerchantReferralOptionHeader>
          </MerchantRegistrationOptionDiv>
          <RegistrationMethodsNav
            isFormActive={() =>
              this.props.location.pathname.startsWith(
                '/merchants/registrations/form'
              )
            }
          />
          <MerchantRegistrationHeaderDiv>
            <h5>Upload CSV file</h5>
            <Mobile>
              <p>
                This is best suited for you to register multiple merchants.
                Upload a CSV file with all your merchants information and our
                system will do the rest.{' '}
              </p>
            </Mobile>
            <p>
              Once the merchant application is approved, your merchant will
              receive an email to accept the terms of service and set up a
              password for their account.
            </p>
          </MerchantRegistrationHeaderDiv>

          <ImportCsvDiv>
            <div>
              <DownloadCsvItemDiv>
                <DownloadIconTextLinkDiv
                  href={`${process.env.PUBLIC_URL ||
                    ''}/partner_merchant_application_example.csv`}
                  target="_blank"
                  rel="noopener noreferrer"
                  download={'CSV Template'}
                >
                  <img src={downloadFile} alt="" />
                  <h5>Download Csv template</h5>
                </DownloadIconTextLinkDiv>
                <p>
                  For the import to work properly you will need to structure the
                  CSV file exactly the same as our template.
                </p>
              </DownloadCsvItemDiv>
              <DownloadCsvItemDiv>
                <DownloadIconTextLinkDiv
                  href="https://developers.net-cents.com/partner#merchant-applications-upload-csv"
                  target="_blank"
                  rel="noopener noreferrer"
                  reverseIcon
                >
                  <DefaultIcon name="chevronRight" colorName={'blue'} />
                  <h5>Read Required Information</h5>
                </DownloadIconTextLinkDiv>
                <p>
                  This article explains in more detail what and how your
                  merchants information should be provided in the CSV.{' '}
                  <StyledA
                    href="https://developers.net-cents.com/partner#merchant-applications-upload-csv"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Please read carefully
                  </StyledA>{' '}
                  before attempting to upload the CSV file.
                </p>
              </DownloadCsvItemDiv>
            </div>
            <UploadCsvForm />
          </ImportCsvDiv>
          <Default>
            <FailedMerchants />
          </Default>
        </MerchantReferralOptionDiv>
        <Mobile>
          <FailedMerchants />
        </Mobile>
      </div>
    );
  }
}
